import React, { useEffect, useState } from 'react';
import { 
  IonContent, 
  IonPage, 
  IonProgressBar,
  IonIcon,
} from '@ionic/react';
import { checkmarkCircle } from 'ionicons/icons';
import Axios from 'axios';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import {URLS} from '../assets/URLS';

import { 
  Toolbar, 
  Grid, 
  TextField, 
   FormControlLabel,
   Checkbox,} from '@material-ui/core';

import {Diary} from '../assets/DataStructures'

import { useAuth0 } from "@auth0/auth0-react";
import useStyles from '../assets/cssClasses';


interface dbProps {
  diary: Diary | null,
  type: string | "ADD",
  id: string | null,
}

const DiaryGeneralEditForm: React.FC<dbProps> = (props) => {

  const [processing, setProcessing] = useState<boolean>(false);

  const [diary, setDiary] = useState<Diary>(new Diary());

  const classes = useStyles();

  const { user} = useAuth0();

 
  
  useEffect(()=>{
    if(props.diary){
      setDiary(props.diary)
    }
  },[props.diary])

  
  const postSurvey = () =>{
    setProcessing(true);
    console.log(diary);
    var formData = new FormData();
    alert(JSON.stringify(diary.active));
    alert(JSON.stringify(diary.active.valueOf()))
    formData.append('varsList', diary.file);
    formData.append('path', diary.path);
    formData.append('respondent_name', diary.respondent_name);
    formData.append('description', diary.description);
    formData.append('baseURL', diary.url);
    formData.append('apiKey', diary.api_key);
    formData.append('name', diary.name);
    formData.append('notifications', JSON.stringify(diary.messages));
    formData.append('admin', user.email);
    formData.append('active', JSON.stringify(diary.active));

    alert(JSON.stringify(formData))
    console.log(formData);

    if(props.type==="UPDATE"){
      formData.append('id', props.id?props.id:'');
    }

      Axios.post(URLS.post_survey, formData).then(function(response){
        setProcessing(false);
      })

  } 

  const setFile = (files: any) => {
    diary.file = files[0];
  }



  const setAttr = (value: any, name: string) => {
    var n_diary = {...diary};
    n_diary[name as keyof typeof n_diary] = value;
    console.log(n_diary);
    setDiary(n_diary);
  }

  return (
    <IonPage>
      <IonContent>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AppBar className={classes.page_title} position="sticky">
            <Toolbar>
              <Typography className={classes.title} variant="h6">Bright MR || DSM - Edit General Diary Info</Typography>
            </Toolbar>
          </AppBar>
        </Grid>
        <Grid item xs={12}>
        <TextField id="new_diary_name" label="Survey Name" value={diary.name} onChange={e => setAttr(e.target.value, 'name')} fullWidth={true}/>
   
   <TextField id="new_diary_name_resp" label="Respondent Survey Name" value={diary.respondent_name} onChange={e => setAttr(e.target.value, 'respondent_name')} fullWidth={true}/>

   <TextField id="description" label="Description" value={diary.description} onChange={e => setAttr(e.target.value, 'description')} fullWidth={true}/>
   
   <TextField id="new_diary_path" label="Survey Path" value={diary.path} onChange={e => setAttr(e.target.value, 'path')} fullWidth={true}/>

   <TextField id="new_diary_url" label="Base URL" value={diary.url} onChange={e => setAttr(e.target.value, 'url')} fullWidth={true}/>

   <TextField id="new_diary_apikey" label="API key" value={diary.api_key} onChange={e => setAttr(e.target.value, 'api_key')} fullWidth={true}/>

 
            
   


   <FormControlLabel
              control={
                <Checkbox
                  checked={diary.active?.valueOf()}
                  onChange={e => setAttr(e.target.checked, 'active')}
                  name="checkedActive"
                  color="primary"
                />
              }
              label="Active"
            />

          <React.Fragment>
              <label htmlFor='ids_file'>UPLOAD FILE with IDS for appendance</label>
              <input type='file' onChange={(e) => setFile(e.target.files)} id='ids_file' className={classes.file_input}></input>
            </React.Fragment>
        </Grid>
      </Grid>


        {processing && 
          <IonProgressBar type="indeterminate"></IonProgressBar>
        }
        <Button color="primary" onClick={()=>postSurvey()} startIcon={<IonIcon icon={checkmarkCircle}/>} className={classes.actionButton}>SAVE</Button>
        </IonContent>
    </IonPage>
  );
};

export {DiaryGeneralEditForm};
